import { getApiHOCs } from 'selectors';

export const getFiltersListApiHOC = state => getApiHOCs(state).filtersListApiHOC;
export const getProductsListApiHOC = state => getApiHOCs(state).productsListApiHOC;
export const getProductApiHOC = state => getApiHOCs(state).productApiHOC;
export const getAddProductApiHOC = state => getApiHOCs(state).addProductApiHOC;
export const getOrdersApiHOC = state => getApiHOCs(state).ordersApiHOC;



// WEBPACK FOOTER //
// ./src/components/apiHOCs/selectors.js